import React from 'react'
import './Style.css';
import './App.css';

import {BrowserRouter, Routes, Route } from 'react-router-dom'

import Home from './pages/Home'
import Aboutus from './pages/Aboutus'
import Products from './pages/Products'
import Solutions from './pages/Solutions'
import Sustainability from './pages/Sustainability'
import Investorshub from './pages/Investorshub'
import Careers from './pages/Careers'
import Contact from './pages/Contact'
import Search from './pages/Search'

import DownloadCertificates from './pages/DownloadCertificates'
import Privacypolicy from './pages/Privacypolicy'
import Termcondition from './pages/Termcondition'

import Essence from './pages/about/Essence'
import Vision from './pages/about/Vision'
import Milestone from './pages/about/Milestone';
import Minds from './pages/about/Minds'
import CaseStudy from './pages/about/CaseStudy'
import Reach from './pages/about/Reach'

import SolarModule from './pages/product/SolarModule'
import SolarCell from './pages/product/SolarCell'
import Mounting from './pages/product/Mounting'


import SuccessStoryDetails from './pages/SuccessStoryDetails'
import Blog from './pages/Blog'
import BlogDetails from './pages/BlogDetails'
import SolutionSection from './pages/solution/Section'


function App() {
  return (
    
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/home' element={<Home/>} />
      <Route path='/about-us' element={<Aboutus/>} />
      <Route path='/products' element={<Products/>} />
      <Route path='/solutions' element={<Solutions/>} />
      <Route path='/sustainability' element={<Sustainability/>} />
      <Route path='/investors-hub' element={<Investorshub/>} />
      <Route path='/careers' element={<Careers/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/success-story/details/:slug' element={<SuccessStoryDetails/>} />
      <Route path='/download-certificates' element={<DownloadCertificates/>} />
      <Route path='/blog' element={<Blog/>} />
      <Route path='/blog/details/:slug' element={<BlogDetails/>} />


      <Route path='/privacy-policy' element={<Privacypolicy/>} />
      <Route path='/term-condition' element={<Termcondition/>} />


      {/*  Mobile Device Routes here */}
      <Route path='/about/essence' element={<Essence/>} />
      <Route path='/about/vision' element={<Vision/>} />
      <Route path='/about/milestone' element={<Milestone/>} />
      <Route path='/about/minds' element={<Minds/>} />
      <Route path='/about/case-studies' element={<CaseStudy/>} />
      <Route path='/about/reach' element={<Reach/>} />

      <Route path='/product/solar-module' element={<SolarModule/>} />
      <Route path='/product/solar-cell' element={<SolarCell/>} />
      <Route path='/product/mounting-structure' element={<Mounting/>} />

      <Route path='/solution/section/:slug' element={<SolutionSection/>} />
      <Route path='/search/:query' element={<Search/>} />
    </Routes>
    </BrowserRouter>
  )
}

export default App